import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const WeeklySaleIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '70', viewBox = '0 0 70 70' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect id='Rectangle_884' data-name='Rectangle 884' width='70' height='70' fill='none' />
      <g id='holiday' transform='translate(0 8.75)'>
        <path
          id='Path_7257'
          data-name='Path 7257'
          d='M279,285.921a4.106,4.106,0,0,0,4.1,4.1h4.819a4.106,4.106,0,0,0,4.1-4.1V281.1a4.106,4.106,0,0,0-4.1-4.1H283.1a4.106,4.106,0,0,0-4.1,4.1Zm4.1-4.819h4.819l0,4.819H283.1Z'
          transform='translate(-250.392 -248.597)'
          fill={fill}
          opacity={0.6}
        />
        <circle
          id='Ellipse_101'
          data-name='Ellipse 101'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(37.529 19.482)'
          fill={fill}
          opacity={0.6}
        />
        <circle
          id='Ellipse_102'
          data-name='Ellipse 102'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(28.608 19.482)'
          fill={fill}
          opacity={0.6}
        />
        <path
          id='Path_7258'
          data-name='Path 7258'
          d='M50.449,36.094A2.051,2.051,0,0,0,52.5,34.043V12.3a8.212,8.212,0,0,0-8.2-8.2H41.631V2.051a2.051,2.051,0,0,0-4.1,0V4.1H28.2V2.051a2.051,2.051,0,0,0-4.1,0V4.1H14.868V2.051a2.051,2.051,0,0,0-4.1,0V4.1H8.2A8.212,8.212,0,0,0,0,12.3V44.3a8.212,8.212,0,0,0,8.2,8.2H44.3a8.212,8.212,0,0,0,8.2-8.2,2.051,2.051,0,0,0-4.1,0,4.106,4.106,0,0,1-4.1,4.1H8.2a4.106,4.106,0,0,1-4.1-4.1V12.3A4.106,4.106,0,0,1,8.2,8.2h2.563v2.051a2.051,2.051,0,0,0,4.1,0V8.2H24.1v2.051a2.051,2.051,0,0,0,4.1,0V8.2h9.331v2.051a2.051,2.051,0,0,0,4.1,0V8.2H44.3a4.106,4.106,0,0,1,4.1,4.1V34.043A2.051,2.051,0,0,0,50.449,36.094Z'
          fill={fill}
        />
        <circle
          id='Ellipse_103'
          data-name='Ellipse 103'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(10.767 37.324)'
          fill={fill}
          opacity={0.6}
        />
        <circle
          id='Ellipse_104'
          data-name='Ellipse 104'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(10.767 19.482)'
          fill={fill}
          opacity={0.6}
        />
        <circle
          id='Ellipse_105'
          data-name='Ellipse 105'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(10.767 28.403)'
          fill={fill}
          opacity={0.6}
        />
        <circle
          id='Ellipse_106'
          data-name='Ellipse 106'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(19.688 28.403)'
          fill={fill}
          opacity={0.6}
        />
        <circle
          id='Ellipse_107'
          data-name='Ellipse 107'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(19.688 19.482)'
          fill={fill}
          opacity={0.6}
        />
        <circle
          id='Ellipse_108'
          data-name='Ellipse 108'
          cx='2.051'
          cy='2.051'
          r='2.051'
          transform='translate(19.688 37.324)'
          fill={fill}
          opacity={0.6}
        />
      </g>
    </svg>
  )
);
WeeklySaleIcon.displayName = 'WeeklySaleIcon';

export default WeeklySaleIcon;
